<div class="insights-container">
  <div class="insights-header">
    <span class="insights-title">{{ 'Home.cphainsights' | translate }}</span>
  </div>
    <iframe
      class="insights-iframe"
      [src]="insightsUrl"
      frameborder="0"
      allowtransparency="true"
    scrolling="no"
    ></iframe>
</div>